<div class="dialog-container">
  <h2 class="h2-center">Save custom filter</h2>
  <mat-dialog-content>
    <mat-form-field class="form-field-width100">
      <mat-label>Filter name</mat-label>
      <input matInput class="input-name" placeholder="Ex. Filters1" type="text" [(ngModel)]="value" (keydown)="allowOnlyValidChars($event,$event.target)">
      @if (value) {
      <button matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
        <mat-icon>close</mat-icon>
      </button>
      }
      @if (error) {
        <mat-hint class="error-red">{{errorText}}</mat-hint>
      }

    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="actions">
      <button mat-flat-button (click)="close()">Close</button>
      <div></div>
      <button mat-flat-button (click)="save()" color="primary">Set Filter</button>
    </div>
  </mat-dialog-actions>
</div>
